import axios from "axios";
import qs from "qs";
import {BACK_OFFICE_API, ORDER_API, POS_API} from "../constants/apiUrls"
import {getUserInfo} from "../utils/CommonUtils";
import {newTestApiUrl} from "../constants/apiUrls";

// 주문 채널 메뉴 조회 API
export const getOrderMenuApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/menu/group/ceo`, {
    params: {
      shopId: shopId
    },
    headers: {Authorization: `Bearer ceo-${shopId}`}
  });

  return response.data;
}

// 주문 채널 메뉴 그룹 상세 조회 API
export const getOrderMenuGrpDetailApi = async (shopId, menuGroupId) => {
  const response = await axios.get(`${ORDER_API}/menu/group/ceo/${menuGroupId}`, {
    headers: {Authorization: `Bearer ceo-${shopId}`}
  });

  return response.data;
}


// 주문 채널 메뉴 그룹 등록/수정/삭제 API
export const setOrderMenuGrpApi = async (data) => {
  const response = await axios.post(`${ORDER_API}/menu/v2/group`, data);

  return response.data;
}
// 주문 채널 메뉴 등록/수정/삭제 API
export const setOrderMenuApi = async (data) => {
  const response = await axios.post(`${ORDER_API}/menu/v2`, data);

  return response.data;
}
// 주문 채널 메뉴 상세 조회 API
export const getOrderMenuDetailApi = async (menuId, shopId) => {
  const response = await axios.get(`${ORDER_API}/menu/ceo/${menuId}`, {
    headers: {Authorization: `Bearer ceo-${shopId}`},
  });

  return response.data;
}

// 관리자 채널 메뉴 수정 API
export const setAdminMenuApi = async (menuId, data) => {
  await axios.put(`${BACK_OFFICE_API}/menu/${menuId}`, data);
}

// 관리자 채널 메뉴 상세 조회 API
export const getAdminMenuDetailApi = async (menuId) => {
  let response = await axios.get(`${BACK_OFFICE_API}/menu/${menuId}`);

  return response.data[0];
}

// 관리자 채널 메뉴 이미지 조회 API
export const getAdminMenuImageApi = async (menuId, type) => {
  let response = await axios.get(`${BACK_OFFICE_API}/menu/img`, {
    params: {
      id: menuId,
      type: type
    }
  });

  return response.data;
}

// 포스 채널 메뉴 그룹 등록 API
export const newPosMenuGrpApi = async (data) => {
  const response = await axios.post(`${POS_API}/product/v2/group`, data);

  return response.data.productGroupId;
}

// 포스 채널 메뉴 그룹 수정 API
export const setPosMenuGrpAPi = async (data) => {
  await axios.put(`${POS_API}/product/v2/group`, data);
}

// 포스 채널 메뉴 그룹 삭제 API
export const deletePosMenuGrpAPi = async (data) => {
  await axios.delete(`${POS_API}/product/v2/group`, {
    params: data
  });
}

// 포스 채널 메뉴 등록 API
export const newPosMenuApi = async (data) => {
  const response = await axios.post(`${POS_API}/product/v2`, data);

  return response.data.productIdList[0];
}

// 포스 채널 메뉴 상세 조회 API
export const getPosMenuDetailApi = async (menuId) => {
  const response = await axios.get(`${POS_API}/product/v2/${menuId}`);

  return response.data;
}

// 포스 채널 메뉴 수정 API
export const setPosMenuApi = async (data) => {
  await axios.put(`${POS_API}/product/v2`, data);
}

// 포스 채널 메뉴 삭제 API
export const deletePosMenuApi = async (data) => {
  await axios.delete(`${POS_API}/product/v2`, {
    params: data
  });
}

// 주문 채널 가격 등록/수정/삭제 API
export const setOrderMenuCostApi = async (data) => {
  const response = await axios.post(`${ORDER_API}/cost/menu`, data);

  return response.data.addMenuCostIdList;
}

// 포스 채널 가격 등록 API
export const newPosMenuCostApi = async (data) => {
  await axios.post(`${POS_API}/product/v2/cost`, data);
}

// 포스 채널 가격 수정 API
export const setPosMenuCostApi = async (data) => {
  await axios.put(`${POS_API}/product/v2/cost`, data);
}

// 포스 채널 가격 삭제 API
export const deletePosMenuCostApi = async (data) => {
  await axios.delete(`${POS_API}/product/v2/cost`, {
    params: data
  });
}

// 주문 채널 옵션 그룹 조회 API
export const getOrderOptionGrpApi = async (shopId) => {
  const response = await axios.get(`${ORDER_API}/menu/option/group/ceo`, {
    headers: {Authorization: `Bearer ceo-${shopId}`},
    params: {shopId: shopId}
  });

  return response.data;
}

// 주문 채널 메뉴 옵션 조회 API
export const getOrderMenuOptionListApi = async (menuId) => {
  const response = await axios.get(`${ORDER_API}/menu/v2/option/group`, {
    params: {menuId: menuId}
  });

  return response.data;
}

// 주문 채널 메뉴 옵션 등록/삭제 API
export const setOrderMenuOptionApi = async (data) => {
  await axios.post(`${ORDER_API}/menu/v2/option/group/mapping`, data);
}

// 포스 채널 메뉴 옵션 등록 API
export const newPosMenuOptionApi = async (data) => {
  await axios.post(`${POS_API}/product/v2/option-group/mapping`, data);
}








/**
 * 이하 함수는 서버 대상 식별 불가
 * 함수 내부 주석처리
 * 
 * @date 2026-04-17
 * @author Saccharin01
 */

// new 메뉴 조회
export const newGetMenuListApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/products/groups`, {
  //   headers: {Authorization: `Bearer ${accessToken}`},
  //   params: data
  // });

  // return response.data;
}

// new 메뉴 상세 조회
export const newGetMenuDetailApi = async (productId) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/products/${productId}`, {
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });

  // return response.data;
}

// new 추가용 옵션 리스트 조회
export const newGetAddOptionListApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/products/options/groups/add-product`, {
  //   headers: {Authorization: `Bearer ${accessToken}`},
  //   params: data
  // });

  // return response.data;
}

// new 옵션 리스트 조회
export const newGetOptionListApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // const response = await axios.get(`${newTestApiUrl}/ceo/products/options/groups`, {
  //   headers: {Authorization: `Bearer ${accessToken}`},
  //   params: data
  // });

  // return response.data;
}

// new 메뉴그룹 추가
export const newAddMenuGroupApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // await axios.post(`${newTestApiUrl}/ceo/products/groups`, data,{
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });
}

// new 메뉴 추가
export const newAddMenuApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // await axios.post(`${newTestApiUrl}/ceo/products`, data,{
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });
}

// new 옵션그룹 추가
export const newAddOptionGroupApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // await axios.post(`${newTestApiUrl}/ceo/products/options/groups`, data,{
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });
}

// new 메뉴그룹 수정
export const newSetMenuGroupApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // await axios.put(`${newTestApiUrl}/ceo/products/groups`, data,{
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });
};

// new 메뉴 수정
export const newSetMenuApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // await axios.put(`${newTestApiUrl}/ceo/products`, data,{
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });
};

// new 옵션그룹 수정
export const newSetOptionGroupApi = async (data) => {
  // const {accessToken} = getUserInfo();

  // await axios.put(`${newTestApiUrl}/ceo/products/options/groups`, data,{
  //   headers: {Authorization: `Bearer ${accessToken}`}
  // });
};


// new 메뉴그룹 삭제
export const deleteMenuGroupApi = async (productGroupIds) => {
  // const { accessToken } = getUserInfo();

  // const query = qs.stringify({ productGroupIds }, { arrayFormat: "repeat" });
  // const url = `${newTestApiUrl}/ceo/products/groups?${query}`;

  // await axios.delete(url, {
  //   headers: {
  //     Authorization: `Bearer ${accessToken}`,
  //   },
  // });
};

// new 메뉴 삭제
export const deleteMenuApi = async (productIds) => {
  // const { accessToken } = getUserInfo();

  // const query = qs.stringify({ productIds }, { arrayFormat: "repeat" });
  // const url = `${newTestApiUrl}/ceo/products?${query}`;

  // await axios.delete(url, {
  //   headers: {
  //     Authorization: `Bearer ${accessToken}`,
  //   },
  // });
};

// new 옵션 그룹 삭제
export const deleteOptionGroupApi = async (productOptionGroupIds) => {
  // const { accessToken } = getUserInfo();

  // const query = qs.stringify({ productOptionGroupIds }, { arrayFormat: "repeat" });
  // const url = `${newTestApiUrl}/ceo/products/options/groups?${query}`;

  // await axios.delete(url, {
  //   headers: {
  //     Authorization: `Bearer ${accessToken}`,
  //   },
  // });
};

// new 옵션 삭제
export const deleteOptionApi = async (productOptionIds) => {
  // const { accessToken } = getUserInfo();

  // const query = qs.stringify({ productOptionIds }, { arrayFormat: "repeat" });
  // const url = `${newTestApiUrl}/ceo/products/options?${query}`;

  // await axios.delete(url, {
  //   headers: {
  //     Authorization: `Bearer ${accessToken}`,
  //   },
  // });
};